
import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  MenuItem,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
//import axios from './AxiosInstance';
import { fetchWithAuth } from './fetchWithAuth';
function OrderProvisionForm() {
  const [formData, setFormData] = useState({
    imei: '12345',
    name_to_assign: '',
    sectionId: 0,
  });

  const [errors, setErrors] = useState({});
  const [serverResponse, setServerResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [lastUsedSectionId, setLastUsedSectionId] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [proceedAfterConfirm, setProceedAfterConfirm] = useState(false);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [sectionLoading, setSectionLoading] = useState(true);

  // Fetch section list
  useEffect(() => {
    fetchWithAuth(`/api/sections`)
      //.then(res => res.json())
      .then(data => {
        setSectionOptions(data);
        setSectionLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch sections:', err);
        setSectionLoading(false);
      });
  }, []);

  // Fetch last section ID
  useEffect(() => {
    fetchWithAuth(`/api/last-section-id`)
      //.then(res => res.json())
      .then(data => {
        const id = data.lastSectionId ?? 0;
        setLastUsedSectionId(id);
        setFormData(prev => ({ ...prev, sectionId: id }));
      })
      .catch(err => console.error('Failed to fetch last section ID:', err));
  }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

   
  // let newValue = value;
  // if (name === 'name_to_assign') {
  //   newValue = value.toUpperCase(); // Convert to uppercase
  // }
  //   if (name === 'imei' && value.length > 15) return;

  //   setFormData(prev => ({
  //     ...prev,
  //     [name]: name === 'sectionId' ? Number(value) : value,
  //   }));

  //   setErrors(prev => ({
  //     ...prev,
  //     [name]: '',
  //   }));
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    let newValue = value;
    if (name === 'name_to_assign') {
      newValue = value.toUpperCase(); // Convert to uppercase
    }
  
    if (name === 'imei' && newValue.length > 15) return;
  
    setFormData(prev => ({
      ...prev,
      [name]: name === 'sectionId' ? Number(newValue) : newValue,
    }));
  
    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };
  
  const validate = () => {
    let valid = true;
    let newErrors = {};

    if (!formData.imei || !/^\d{5,15}$/.test(formData.imei)) {
      newErrors.imei = 'IMEI must be 5–15 digits';
      valid = false;
    }

    if (!formData.name_to_assign.trim()) {
      newErrors.name_to_assign = 'Please enter a provision name';
      valid = false;
    }

    if (
      formData.sectionId === '' ||
      formData.sectionId === null ||
      isNaN(formData.sectionId)
    ) {
      newErrors.sectionId = 'Please select a section';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const checkProvisionAndImei = async () => {
    try {
      const [nameRes, imeiRes] = await Promise.all([
        fetchWithAuth(`/api/check-provision-name?name=${formData.name_to_assign}`),
        fetchWithAuth(`/api/check-imei?imei=${formData.imei}`),
      ]);

      const nameData = await nameRes;
      const imeiData = await imeiRes;

      if (imeiData.exists) {
        setErrors({ imei: 'IMEI already exists' });
        return false;
      }

      if (nameData.exists) {
        setShowConfirmDialog(true);
        return false;
      }

      return true;
    } catch (err) {
      console.error('Validation check failed:', err);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    if (!proceedAfterConfirm) {
      const isValid = await checkProvisionAndImei();
      if (!isValid) return;
    }

    submitToServer();
  };

  const submitToServer = async () => {
    setLoading(true);
    setServerResponse(null);

    try {
      const response = await fetchWithAuth(`/api/orderprovision`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      //const text = await response;

      try {
        //const result = JSON.parse(text);
        setServerResponse(response);
      } catch {
        setServerResponse({ error: 'Server returned non-JSON response' });
      }
    } catch (err) {
      console.error('Submission error:', err);
      setServerResponse({ error: 'Failed to submit form' });
    } finally {
      setLoading(false);
      setShowConfirmDialog(false);
      setProceedAfterConfirm(false);
    }
  };

  const handleDialogConfirm = () => {
    setShowConfirmDialog(false);
    setProceedAfterConfirm(true);
    submitToServer();
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        maxWidth: 400,
        mx: 'auto',
        mt: 4,
        p: 3,
        border: '1px solid #ccc',
        borderRadius: 2,
      }}
    >
      <Typography variant="h5" mb={2} textAlign="center">
       Provision New Device
      </Typography>

      <TextField
        label="IMEI Number"
        name="imei"
        value={formData.imei}
        onChange={handleChange}
        fullWidth
        margin="normal"
        inputProps={{ maxLength: 15 }}
        error={!!errors.imei}
        helperText={errors.imei}
      />

      <TextField
        label="Name (Provision Name)"
        name="name_to_assign"
        value={formData.name_to_assign}
        onChange={handleChange}
        fullWidth
        margin="normal"
        error={!!errors.name_to_assign}
        helperText={errors.name_to_assign}
      />

      {sectionLoading ? (
        <CircularProgress size={24} />
      ) : (
        <TextField
          select
          label="Section"
          name="sectionId"
          value={formData.sectionId}
          onChange={handleChange}
          fullWidth
          margin="normal"
          error={!!errors.sectionId}
          helperText={errors.sectionId}
        >
          {sectionOptions.map((section) => (
            <MenuItem
              key={section.id}
              value={section.id}
              sx={{
                backgroundColor:
                  lastUsedSectionId === section.id ? '#fff3cd' : 'inherit',
              }}
            >
              {section.name}
            </MenuItem>
          ))}
        </TextField>
      )}

      <Button
        variant="contained"
        type="submit"
        fullWidth
        sx={{ mt: 3 }}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} /> : 'Submit'}
      </Button>

      {serverResponse && (
        <Box mt={2} p={2} sx={{ bgcolor: '#f0f0f0', borderRadius: 1 }}>
          {serverResponse.error ? (
            <Typography color="error">{serverResponse.error}</Typography>
          ) : (
            <Typography color="success.main">
              {serverResponse.message || 'Success!'}
            </Typography>
          )}
        </Box>
      )}

      <Dialog
        open={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle
          id="confirm-dialog-title"
          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
        >
          <WarningAmberIcon color="warning" />
          Duplicate Provision Name
        </DialogTitle>

        <DialogContent dividers>
          <Typography variant="body1" gutterBottom>
            A provision with the same name already exists in the system.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            If you continue, the new provision will still be submitted using this name.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setShowConfirmDialog(false)} color="error" variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleDialogConfirm} autoFocus color="primary" variant="contained">
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default OrderProvisionForm;
